import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Employee } from '@app/models/employee/employee.model';
import { ApplicantTrackerResources } from '../applicant-tracker.resource';
import { Attach, Detach, HiriingTeamAssignJSONApiRequest } from '../interfaces/hiring-team-assign.interface';

@Injectable()
export class HiringTeamAssignmentService {
    constructor(private http: HttpClient) {}

    async assign(jobPostingId: number, attach?: Attach, detach?: Detach): Promise<void> {
        // Create payload for assignment request.
        const payload: HiriingTeamAssignJSONApiRequest = {
            data: {
                attributes: {
                    attach,
                    detach,
                },
            },
        };

        await this.http
            .post(ApplicantTrackerResources.AssignHiringTeam.replace(':jobPosting', jobPostingId.toString()), payload)
            .toPromise();
    }

    createAttach(employees: Employee[]): Attach {
        return {
            hiringTeamMembers: employees.map((employee: Employee) => {
                return { employeeId: employee.id, accessLevelId: employee.accessLevelId };
            }),
        };
    }

    createDetach(employees: Employee[]): Detach {
        return {
            hiringTeamMembers: employees.map((employee: Employee) => {
                return { employeeId: employee.id };
            }),
        };
    }
}
